(function () {
  "use strict";

  document.querySelectorAll("[data-classes-events]").forEach(initClassesEvents);

  function initClassesEvents(root) {
    const configEl = root.querySelector("[data-classes-events-config]");
    const config = configEl ? JSON.parse(configEl.textContent) : {};
    const apiBase = (config.workerApiBase || "").replace(/\/$/, "");
    const currencyCode = config.currencyCode || "USD";

    const statusEl = root.querySelector("[data-classes-status]");
    const gridEl = root.querySelector("[data-classes-grid]");
    const overlayEl = root.querySelector("[data-detail-overlay]");
    const detailContentEl = root.querySelector("[data-detail-content]");
    const closeBtn = root.querySelector("[data-detail-close]");
    const lightboxEl = root.querySelector("[data-image-lightbox]");
    const lightboxImg = root.querySelector("[data-image-lightbox-img]");
    const lightboxCloseBtn = root.querySelector("[data-image-lightbox-close]");

    if (!apiBase) {
      statusEl.textContent = "Classes are temporarily unavailable — check back soon.";
      return;
    }

    let classes = [];

    fetch(apiBase + "/api/classes")
      .then((res) => {
        if (!res.ok) throw new Error("Request failed: " + res.status);
        return res.json();
      })
      .then((data) => {
        classes = data.classes || [];
        renderGrid();
      })
      .catch(() => {
        statusEl.textContent = "We couldn't load classes right now — please refresh the page.";
      });

    function formatMoney(amount) {
      const value = parseFloat(amount);
      try {
        return new Intl.NumberFormat(undefined, { style: "currency", currency: currencyCode }).format(value);
      } catch (e) {
        return "$" + value.toFixed(2);
      }
    }

    function escapeHtml(value) {
      return String(value == null ? "" : value).replace(/[&<>"']/g, (c) => {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }

    function bestAvailableSeats(sessions) {
      const available = sessions.filter((s) => !s.soldOut);
      if (available.length === 0) return null;
      return Math.min.apply(
        null,
        available.map((s) => s.seatsLeft)
      );
    }

    function renderGrid() {
      if (classes.length === 0) {
        statusEl.textContent = "No upcoming classes right now — check back soon.";
        gridEl.hidden = true;
        return;
      }

      statusEl.hidden = true;
      gridEl.hidden = false;

      gridEl.innerHTML = classes
        .map((c, index) => {
          const seats = bestAvailableSeats(c.sessions);
          const seatsBadge =
            seats === null
              ? '<span class="classes-events__seats is-sold-out">Sold Out — join waitlist</span>'
              : '<span class="classes-events__seats">' + seats + (seats === 1 ? " spot left" : " spots left") + "</span>";
          const imageStyle = c.imageUrl ? ' style="background-image:url(&quot;' + escapeHtml(c.imageUrl) + '&quot;)"' : "";
          const imageAttr = c.imageUrl ? ' data-lightbox-url="' + escapeHtml(c.imageUrl) + '"' : "";

          return (
            '<article class="classes-events__card" data-class-index="' +
            index +
            '">' +
            '<div class="classes-events__card-image"' +
            imageStyle +
            imageAttr +
            "></div>" +
            '<div class="classes-events__card-body">' +
            '<h2 class="classes-events__card-title">' +
            escapeHtml(c.title) +
            "</h2>" +
            '<div class="classes-events__card-meta">' +
            (c.instructor ? "<span>with " + escapeHtml(c.instructor) + "</span>" : "") +
            (c.durationLabel ? "<span>" + escapeHtml(c.durationLabel) + "</span>" : "") +
            (c.location ? "<span>" + escapeHtml(c.location) + "</span>" : "") +
            "</div>" +
            '<div class="classes-events__card-desc">' +
            stripHtml(c.descriptionHtml) +
            "</div>" +
            '<div class="classes-events__card-footer">' +
            '<span class="classes-events__price">' +
            (c.minPrice ? "From " + formatMoney(c.minPrice) : "") +
            "</span>" +
            seatsBadge +
            "</div>" +
            '<div class="classes-events__card-footer">' +
            '<button type="button" data-view-class>View details &amp; book</button>' +
            "</div>" +
            "</div>" +
            "</article>"
          );
        })
        .join("");

      gridEl.querySelectorAll("[data-class-index]").forEach((card) => {
        card.querySelector("[data-view-class]").addEventListener("click", () => {
          openDetail(classes[parseInt(card.getAttribute("data-class-index"), 10)]);
        });
        const cardImage = card.querySelector("[data-lightbox-url]");
        if (cardImage) {
          cardImage.addEventListener("click", () => openLightbox(cardImage.getAttribute("data-lightbox-url")));
        }
      });
    }

    function openLightbox(url) {
      if (!url) return;
      lightboxImg.src = url;
      lightboxEl.hidden = false;
    }

    function closeLightbox() {
      lightboxEl.hidden = true;
      lightboxImg.src = "";
    }

    lightboxCloseBtn.addEventListener("click", closeLightbox);
    lightboxEl.addEventListener("click", (e) => {
      if (e.target === lightboxEl) closeLightbox();
    });

    function stripHtml(html) {
      const div = document.createElement("div");
      div.innerHTML = html || "";
      return escapeHtml(div.textContent || "").slice(0, 220);
    }

    function includedListHtml(whatsIncluded) {
      if (!whatsIncluded) return "";
      const items = whatsIncluded
        .split("\n")
        .map((s) => s.trim())
        .filter(Boolean);
      if (items.length === 0) return "";
      return (
        '<div class="classes-events__detail-included"><strong>What’s included</strong><ul>' +
        items.map((i) => "<li>" + escapeHtml(i) + "</li>").join("") +
        "</ul></div>"
      );
    }

    function openDetail(classItem) {
      let selectedSession = classItem.sessions.find((s) => !s.soldOut) || classItem.sessions[0];

      function render() {
        const sessionsHtml = classItem.sessions
          .map((s) => {
            const soldOut = s.soldOut;
            const selected = s.variantId === selectedSession.variantId;
            return (
              '<div class="classes-events__session' +
              (selected ? " is-selected" : "") +
              (soldOut ? " is-sold-out" : "") +
              '" data-variant-id="' +
              s.variantId +
              '">' +
              '<span class="classes-events__session-label">' +
              escapeHtml(s.label) +
              " — " +
              formatMoney(s.price) +
              "</span>" +
              '<span class="classes-events__session-seats">' +
              (soldOut ? "Sold out" : s.seatsLeft + (s.seatsLeft === 1 ? " spot left" : " spots left")) +
              "</span>" +
              "</div>"
            );
          })
          .join("");

        const maxQty = selectedSession.soldOut ? 0 : selectedSession.seatsLeft;

        const purchaseSectionHtml = selectedSession.soldOut
          ? '<div class="classes-events__waitlist" data-waitlist>' +
            '<p class="classes-events__attendees-hint">This date is full. Join the waitlist and we will reach out if a seat opens — no payment now.</p>' +
            '<label>Name<input type="text" id="wl-name" required /></label>' +
            '<label>Email<input type="email" id="wl-email" required /></label>' +
            '<label>Phone<input type="tel" id="wl-phone" required /></label>' +
            '<label>Seats wanted<input type="number" id="wl-seats" min="1" value="1" /></label>' +
            '<label>Notes <span class="classes-events__optional">(optional)</span><input type="text" id="wl-notes" /></label>' +
            '<button type="button" class="classes-events__add-to-cart" data-join-waitlist>Join waitlist</button>' +
            "</div>"
          : '<div class="classes-events__purchase-row">' +
            '<label for="ce-qty">Seats</label>' +
            '<input type="number" id="ce-qty" min="1" max="' +
            Math.max(maxQty, 1) +
            '" value="1" />' +
            "</div>" +
            '<p class="classes-events__attendees-hint">Who is coming? We need a name and phone number for each seat.</p>' +
            '<div class="classes-events__attendees" data-attendees></div>' +
            '<button type="button" class="classes-events__add-to-cart" data-add-to-cart>Add to cart</button>';

        detailContentEl.innerHTML =
          (classItem.imageUrl ? '<img class="classes-events__detail-image" src="' + escapeHtml(classItem.imageUrl) + '" alt="" />' : "") +
          "<h2>" +
          escapeHtml(classItem.title) +
          "</h2>" +
          '<div class="classes-events__detail-facts">' +
          (classItem.instructor ? "<span>Instructor: " + escapeHtml(classItem.instructor) + "</span>" : "") +
          (classItem.location ? "<span>Location: " + escapeHtml(classItem.location) + "</span>" : "") +
          (classItem.durationLabel ? "<span>Duration: " + escapeHtml(classItem.durationLabel) + "</span>" : "") +
          (classItem.skillLevel ? "<span>Skill level: " + escapeHtml(classItem.skillLevel) + "</span>" : "") +
          "</div>" +
          '<div class="classes-events__detail-desc">' +
          (classItem.descriptionHtml || "") +
          "</div>" +
          includedListHtml(classItem.whatsIncluded) +
          "<h3>Pick a date</h3>" +
          '<div class="classes-events__sessions" data-session-list>' +
          sessionsHtml +
          "</div>" +
          purchaseSectionHtml +
          '<div class="classes-events__cart-message" data-cart-message></div>';

        const detailImage = detailContentEl.querySelector(".classes-events__detail-image");
        if (detailImage) {
          detailImage.addEventListener("click", () => openLightbox(classItem.imageUrl));
        }

        detailContentEl.querySelectorAll("[data-variant-id]").forEach((row) => {
          row.addEventListener("click", () => {
            const variantId = row.getAttribute("data-variant-id");
            const session = classItem.sessions.find((s) => String(s.variantId) === String(variantId));
            if (!session) return;
            selectedSession = session;
            render();
          });
        });

        if (selectedSession.soldOut) {
          const waitlistBtn = detailContentEl.querySelector("[data-join-waitlist]");
          if (waitlistBtn) {
            waitlistBtn.addEventListener("click", () => joinWaitlist(selectedSession));
          }
        } else {
          const qtyInput = detailContentEl.querySelector("#ce-qty");
          renderAttendeeFields(parseInt(qtyInput.value, 10) || 1);
          qtyInput.addEventListener("input", () => {
            const clamped = Math.min(Math.max(1, parseInt(qtyInput.value, 10) || 1), Math.max(maxQty, 1));
            renderAttendeeFields(clamped);
          });

          const addBtn = detailContentEl.querySelector("[data-add-to-cart]");
          if (addBtn) {
            addBtn.addEventListener("click", () => addToCart(classItem, selectedSession));
          }
        }
      }

      // One name+phone (+optional notes) block per seat — added as separate
      // cart line items (quantity 1 each) so every attendee is individually
      // trackable on the roster, even when one person books several seats.
      function renderAttendeeFields(seatCount) {
        const container = detailContentEl.querySelector("[data-attendees]");
        if (!container) return;
        const previous = Array.from(container.querySelectorAll(".classes-events__attendee")).map((block) => ({
          name: block.querySelector(".ce-attendee-name").value,
          phone: block.querySelector(".ce-attendee-phone").value,
          notes: block.querySelector(".ce-attendee-notes").value,
        }));

        container.innerHTML = Array.from({ length: seatCount })
          .map((_, i) => {
            const prior = previous[i] || { name: "", phone: "", notes: "" };
            return (
              '<fieldset class="classes-events__attendee">' +
              "<legend>Seat " +
              (i + 1) +
              "</legend>" +
              '<label>Name<input type="text" class="ce-attendee-name" required value="' +
              escapeHtml(prior.name) +
              '" /></label>' +
              '<label>Phone<input type="tel" class="ce-attendee-phone" required value="' +
              escapeHtml(prior.phone) +
              '" /></label>' +
              '<label>Notes <span class="classes-events__optional">(allergies, etc. — optional)</span><input type="text" class="ce-attendee-notes" value="' +
              escapeHtml(prior.notes) +
              '" /></label>' +
              "</fieldset>"
            );
          })
          .join("");
      }

      render();
      overlayEl.hidden = false;
      document.body.style.overflow = "hidden";
    }

    function addToCart(classItem, session) {
      const messageEl = detailContentEl.querySelector("[data-cart-message]");
      const addBtn = detailContentEl.querySelector("[data-add-to-cart]");
      const attendeeBlocks = Array.from(detailContentEl.querySelectorAll(".classes-events__attendee"));

      const items = [];
      for (const block of attendeeBlocks) {
        const name = block.querySelector(".ce-attendee-name").value.trim();
        const phone = block.querySelector(".ce-attendee-phone").value.trim();
        const notes = block.querySelector(".ce-attendee-notes").value.trim();
        if (!name || !phone) {
          messageEl.className = "classes-events__cart-message is-error";
          messageEl.textContent = "Please fill in a name and phone number for every seat.";
          return;
        }
        const properties = { "Attendee name": name, "Attendee phone": phone };
        if (notes) properties["Notes"] = notes;
        // quantity 1 each, not one line with quantity N — Shopify only merges
        // line items with identical properties, so distinct attendee info
        // keeps each seat as its own trackable line item.
        items.push({ id: parseInt(session.variantId, 10), quantity: 1, properties: properties });
      }
      if (items.length === 0) {
        messageEl.className = "classes-events__cart-message is-error";
        messageEl.textContent = "Please fill in a name and phone number for every seat.";
        return;
      }

      addBtn.disabled = true;
      messageEl.className = "classes-events__cart-message";
      messageEl.textContent = "Adding to cart…";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then((res) => res.json().then((body) => ({ ok: res.ok, body })))
        .then((result) => {
          addBtn.disabled = false;
          if (!result.ok) {
            const message = (result.body && (result.body.description || result.body.message)) || "This session may be sold out.";
            messageEl.className = "classes-events__cart-message is-error";
            messageEl.textContent = message;
            return;
          }
          messageEl.className = "classes-events__cart-message is-ok";
          messageEl.innerHTML = 'Added to cart. <a href="/cart">View cart</a>';
        })
        .catch(() => {
          addBtn.disabled = false;
          messageEl.className = "classes-events__cart-message is-error";
          messageEl.textContent = "Something went wrong adding this to your cart — please try again.";
        });
    }

    function joinWaitlist(session) {
      const messageEl = detailContentEl.querySelector("[data-cart-message]");
      const btn = detailContentEl.querySelector("[data-join-waitlist]");
      const name = detailContentEl.querySelector("#wl-name").value.trim();
      const email = detailContentEl.querySelector("#wl-email").value.trim();
      const phone = detailContentEl.querySelector("#wl-phone").value.trim();
      const seats = Math.max(1, parseInt(detailContentEl.querySelector("#wl-seats").value, 10) || 1);
      const notes = detailContentEl.querySelector("#wl-notes").value.trim();

      if (!name || !email || !phone) {
        messageEl.className = "classes-events__cart-message is-error";
        messageEl.textContent = "Please fill in your name, email, and phone number.";
        return;
      }

      btn.disabled = true;
      messageEl.className = "classes-events__cart-message";
      messageEl.textContent = "Joining waitlist…";

      fetch(apiBase + "/api/waitlist", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ variantId: session.variantId, seats: seats, name: name, email: email, phone: phone, notes: notes }),
      })
        .then((res) => res.json().then((resBody) => ({ ok: res.ok, body: resBody })))
        .then((result) => {
          btn.disabled = false;
          if (!result.ok) {
            messageEl.className = "classes-events__cart-message is-error";
            messageEl.textContent = (result.body && result.body.error) || "Something went wrong — please try again.";
            return;
          }
          messageEl.className = "classes-events__cart-message is-ok";
          messageEl.textContent = "You're on the waitlist — we'll reach out if a seat opens up.";
          btn.setAttribute("disabled", "disabled");
        })
        .catch(() => {
          btn.disabled = false;
          messageEl.className = "classes-events__cart-message is-error";
          messageEl.textContent = "Something went wrong — please try again.";
        });
    }

    function closeDetail() {
      overlayEl.hidden = true;
      document.body.style.overflow = "";
    }

    closeBtn.addEventListener("click", closeDetail);
    overlayEl.addEventListener("click", (e) => {
      if (e.target === overlayEl) closeDetail();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      if (!lightboxEl.hidden) closeLightbox();
      else if (!overlayEl.hidden) closeDetail();
    });
  }
})();
